<template>
    <button class="flex space-x-2 justify-start items-center text-DentaBlue text-sm">
        <img src="@/assets/icons/pfeil-links-blau.svg" alt="<" class="h-3 aspect-square object-contain">
        <p>Zurück</p>
    </button>
</template>